import React from 'react';
import Button from '@mui/material/Button';
export const TimeSpent = ({ patient, timeSpentRpm, timeSpentCcm }) => {
    return (React.createElement("div", { className: "text-center", style: { marginLeft: 'auto' } },
        patient.rpmConsent &&
            React.createElement(Button, { style: {
                    fontFamily: 'Barlow',
                    color: '#2C78EB',
                    borderRadius: 6,
                    fontWeight: 400,
                    fontSize: 'x-small',
                    cursor: 'auto',
                    backgroundColor: '#2C78EB1A',
                    marginRight: '5px'
                }, color: "inherit", size: "small" },
                React.createElement("span", { style: { fontWeight: 700 } },
                    "RPM: ",
                    timeSpentRpm)),
        patient.ccmConsent &&
            React.createElement(Button, { style: {
                    fontFamily: 'Barlow',
                    color: '#018FB7',
                    borderRadius: 6,
                    fontWeight: 400,
                    fontSize: 'x-small',
                    cursor: 'auto',
                    backgroundColor: '#018FB71A'
                }, color: "inherit", size: "small" },
                React.createElement("span", { style: { fontWeight: 700 } },
                    "CCM: ",
                    timeSpentCcm))));
};
